module.exports = __webpack_public_path__ + "../resources/img/prod_img.ca4c735e.png";